import React, { Component } from 'react'
import PropTypes from 'prop-types'
import TypingIndicator from '../ui/TypingIndicator'
import { OEComponents } from '@opportunityeducation/oe-web-common'

import { inProgress } from '../../utils/messages'

class InProgress extends Component {
  render() {
    return (
      <div className="in-progress-container">
        <img src={this.props.review.reviewer.photo_url} />
        <br />
        <TypingIndicator />
        <h5>{inProgress}</h5>
        <div className="since">
          {'Since '}
          <OEComponents.DateFormatter
            date={this.props.review.created_at}
            includeTime={false}
            abbreviateMonth
          />
          {' at '}
          <OEComponents.Time time={this.props.review.created_at} />
        </div>
      </div>
    )
  }
}

InProgress.propTypes = {
  dispatch: PropTypes.func,
  users: PropTypes.array,
  review: PropTypes.object
}

export default InProgress



// WEBPACK FOOTER //
// ./src/components/reviewqueue/InProgress.js